(function () {
  function initFaqAnimations() {
    document.querySelectorAll('.faq-item').forEach(function (details) {
      if (details.dataset.faqInit) return;
      details.dataset.faqInit = '1';

      var summary = details.querySelector('.faq-item__question');
      var answer  = details.querySelector('.faq-item__answer');
      var busy    = false;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (busy) return;
        busy = true;

        if (details.open) {
          // — cierre: animar height a 0, luego quitar open
          details.classList.remove('faq-item--open');
          var h = answer.offsetHeight + 'px';
          answer.style.height     = h;
          answer.style.transition = 'none';
          answer.offsetHeight; // force reflow
          answer.style.transition = 'height 0.28s ease-in-out, opacity 0.22s ease';
          answer.style.height     = '0';
          answer.style.opacity    = '0';

          answer.addEventListener('transitionend', function onClose(ev) {
            if (ev.propertyName !== 'height') return;
            answer.removeEventListener('transitionend', onClose);
            details.removeAttribute('open');
            answer.style.cssText = '';
            busy = false;
          });

        } else {
          // — apertura: poner open, congelar en 0, animar a altura real
          details.classList.add('faq-item--open');
          details.setAttribute('open', '');
          answer.style.height     = '0';
          answer.style.opacity    = '0';
          answer.style.transition = 'none';
          answer.offsetHeight; // force reflow
          var targetH = answer.scrollHeight + 'px';
          answer.style.transition = 'height 0.28s ease-in-out, opacity 0.22s ease';
          answer.style.height     = targetH;
          answer.style.opacity    = '1';

          answer.addEventListener('transitionend', function onOpen(ev) {
            if (ev.propertyName !== 'height') return;
            answer.removeEventListener('transitionend', onOpen);
            answer.style.cssText = '';
            busy = false;
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqAnimations);
  } else {
    initFaqAnimations();
  }
})();
